<template>
    <div>
        <v-container fluid class="primary py-0 hidden-sm-and-down" v-if="1==0">
            <v-container fluid class="pb-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}">
                <v-row align="center">
                    <v-col cols="12" sm="12" md="6">
                        <h1 class="mb-4 black--text">
                            My Medical Records
                        </h1>
                    </v-col>
                </v-row>
                
            </v-container>
        </v-container>
        <v-container fluid :class="{'px-12': $vuetify.breakpoint.mdAndUp, 'pt-0': $vuetify.breakpoint.smAndDown}" class="mt-6">
            <v-row v-if="userInfo">
                <v-col cols="12" sm="12" md="7" class="hidden-md-and-up">
                    <h2>My Medical Records</h2>
                </v-col>
                <v-col cols="12" sm="12" md="7" class="pt-0">
                    <v-row class="hidden-sm-and-down">
                        <v-col cols="12" sm="12">
                            <v-card outlined>
                                <v-card-text>
                                    <v-row class="pb-0" dense>
                                        <v-col cols="12" sm="12" md="5" class="pb-0">
                                            <v-select v-model="recordFilter" 
                                            solo flat 
                                            class="solo-bordered"
                                            item-text="text"
                                            item-value="value"
                                            item-color="darkPrimary"
                                            :items="recordFilters"></v-select>
                                        </v-col>
                                        <v-spacer></v-spacer>
                                        <v-col cols="12" sm="12" md="5" class="pb-0 d-flex align-sm-end flex-column">
                                           <v-btn rounded class="accent" style="margin-bottom: -20px" @click="addRecordDialog = true">
                                                Add New Record
                                                <v-icon right>mdi-arrow-right</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>

                                    <v-simple-table v-if="!loadingMedicalRecords">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">Date</th>
                                                <th class="text-left">Type</th>
                                                <th class="text-left">Upload Date</th>
                                                <th class="text-left">Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="medicalRecord in medicalRecordsList" :key="medicalRecord.id"
                                                @click="medicalRecordDetails = medicalRecord;"
                                                :class="{'grey lighten-3' : medicalRecordDetails.id === medicalRecord.id}"
                                                class="pointer">
                                                <td style="padding: 12px">
                                                    <v-avatar color="grey lighten-2" size="40" tile>
                                                        <b>
                                                            {{ dateutils.utcToLocal(medicalRecord.created_at).format('DD') }}
                                                            <br>
                                                            {{ dateutils.utcToLocal(medicalRecord.created_at).format('MMM') }}
                                                        </b>
                                                    </v-avatar>
                                                </td>
                                                <td>
                                                    <v-chip>
                                                        {{ medicalRecord.type }}
                                                    </v-chip>
                                                </td>
                                                <td>
                                                    {{ dateutils.utcToLocal(medicalRecord.created_at).format('dddd, D MMMM YYYY') }}
                                                </td>
                                                <td>
                                                    <v-btn small outlined color="darkPrimary" class="mr-2"
                                                    
                                                           @click="medicalRecordDetails = medicalRecord">
                                                        View Record
                                                    </v-btn>
                                                </td>
                                            </tr>
                                            <tr v-if="!medicalRecordsList.length">
                                                <td colspan="5" class="text-center">
                                                    <div class="text-center my-6">
                                                        <v-icon large>mdi-alert</v-icon>
                                                        <br>
                                                        <h3 class="font-weight-regular">No Records Found</h3>
                                                        

                                                        <div class="mt-8 d-flex justify-center align-center">
                                                            <v-btn small outlined
                                                            @click="addRecordDialog = true"
                                                                > New Medical Record
                                                            </v-btn>
                                                            
                                                        </div>
                                                    



                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <div v-if="loadingMedicalRecords" class="py-12 text-center d-flex justify-center">
                                        <v-progress-circular
                                                :size="50"
                                                :width="5"
                                                color="primary"
                                                indeterminate
                                        ></v-progress-circular>
                                    </div>
                                    <v-pagination
                                            color="darkPrimary"
                                            @input="getMedicalRecords"
                                            v-model="page"
                                            :length="medicalRecordsPaginationDetails.last_page"
                                            v-if="medicalRecordsPaginationDetails.total > filters.limit"
                                    ></v-pagination>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!--                    Mobile List UI-->
                    <v-row class="hidden-md-and-up">
                        <v-col cols="12" class="pt-0">
                            <v-row class="pb-0" dense>
                                <v-col cols="6" sm="12" md="5" class="pb-0">
                                    <v-select 
                                    hide-details 
                                    v-model="recordFilter" 
                                    solo flat class="solo-bordered"
                                    item-text="text"
                                    item-value="value"
                                    item-color="darkPrimary"
                                    :items="recordFilters">
                                    </v-select>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="6" sm="12" md="5" class="pb-0">
                                    <v-btn rounded class="accent" style="margin-bottom: -20px" @click="addRecordDialog = true">
                                                Add New Record
                                                <v-icon right>mdi-arrow-right</v-icon>
                                            </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <v-list three-line v-if="!loadingMedicalRecords && medicalRecordsList.length">
                                <v-list-item-group>
                                    <v-divider></v-divider>
                                    <template v-for="medicalRecord in medicalRecordsList">
                                        <v-list-item :key="medicalRecord.id"
                                                     @click="showMedicalRecordDetails(medicalRecord)">
                                            <v-list-item-avatar color="grey lighten-2" tile>

                                                {{ dateutils.utcToLocal(medicalRecord.created_at).format('DD') }}
                                                {{ dateutils.utcToLocal(medicalRecord.created_at).format('MMM') }}
                                            </v-list-item-avatar>

                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    {{ dateutils.utcToLocal(medicalRecord.created_at).format('dddd, hh:mm A') }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ medicalRecord.type}}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-list-item-action-text>
                                                    <v-icon>mdi-chevron-right</v-icon>
                                                </v-list-item-action-text>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="medicalRecord.id"></v-divider>
                                    </template>
                                </v-list-item-group>
                            </v-list>
                            <div v-if="!loadingMedicalRecords && medicalRecordsList.length" class="pt-3">
                                <v-pagination
                                        color="darkPrimary"
                                        @input="getMedicalRecords"
                                        v-model="page"
                                        :length="medicalRecordsPaginationDetails.last_page"
                                        v-if="medicalRecordsPaginationDetails.total > filters.limit"
                                ></v-pagination>
                            </div>
                            <div v-if="loadingMedicalRecords" class="py-12 text-center">
                                <v-progress-circular
                                        :size="50"
                                        :width="5"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </div>
                            <div v-if="!medicalRecordsList.length && !loadingMedicalRecords" class="py-12 text-center">
                                <v-icon x-large>mdi-alert</v-icon>
                                <br>
                                <h3 class="font-weight-regular">No Records Found</h3>
                                 <div class="mt-8 d-flex justify-center align-center">
                                    <v-btn small outlined
                                    @click="addRecordDialog = true"
                                        > New Medical Record
                                    </v-btn>
                                    
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <!--                Details-->
                <v-col cols="12" sm="12" md="5" class="lightPinkBackground hidden-sm-and-down">
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <h2> Record Details</h2>
                            <br>
                        </v-col>
                        
                        <v-col cols="12" class="pt-0">
                            <medical-record-details :key="medicalRecordDetails.id"                                                    
                                                    :medicalRecordDetailsProp="medicalRecordDetails"
                                                    :showActions="true"
                                                    v-on:refreshList="getMedicalRecords()"
                                                    v-if="medicalRecordDetails && medicalRecordDetails.id"
                                                    ></medical-record-details>
                            <v-card style="" flat tile class="mb-4" v-else>

                                <v-card-text class="text-center">
                                    <v-icon x-large>mdi-alert</v-icon>
                                    <br>
                                    <h3 class="font-weight-regular">No Records Found</h3>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" sm="12" class="text-center">
                    <h1>
                        Please login to continue to your Dashboard
                    </h1>
                    <br>
                    <v-btn class="accent-gradient white--text" large @click="goToWebsite('patient-login', false)">
                        Login
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            fullscreen         
            v-model="sheet" 
        >
            <v-toolbar
                dark          
                color="primary"
            >
                <v-btn
                    icon
                    dark
                    color="black"
                    @click="sheet = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title class="black--text"></v-toolbar-title>
                <v-spacer></v-spacer>
            
            </v-toolbar>

            <medical-record-details v-on:refreshList="getMedicalRecords()" 
                :key="medicalRecordDetails.id"
                :medical-record-details-prop="medicalRecordDetails"
                :show-actions="true">
            </medical-record-details>
        </v-dialog>

        <!-- Add Record -->
        <v-dialog v-model="addRecordDialog" max-width="400" persistent>
            <v-card style="position: relative">
                <div style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; background: white; z-index: 1; text-align: center"
                     v-if="uploadSucess">
                    <div style="position: absolute; top: 10%; right: 0; left: 0">
                        <v-icon color="green" style="font-size: 100px" class="mt-12">
                            mdi-checkbox-marked-circle-outline
                        </v-icon>

                        <h3 class="font-weight-regular my-5">Record Uploaded Successfully</h3>

                        <v-btn class="primary" @click="addRecordDialog = uploadSucess = false">Close</v-btn>
                    </div>
                </div>
                <v-card-title>
                    Add Record
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-form id="addMedicalRecord">
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-text-field v-model="recordTitle" label="Name" type="text" name="name" outlined></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-select item-color="darkPrimary" :items="recordTypes" v-model="recordType" name="type" outlined>

                                        </v-select>
                                    </v-col>
                                    

                                    <v-col cols="12" sm="12">
                                        <input type="file" multiple id="attachments"/>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="addRecordDialog = false" class="mr-3">
                        Close
                    </v-btn>
                    <v-btn color="accent" @click.prevent="uploadRecord" :loading="saveLoading" :disabled="saveLoading">
                        Upload
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-btn
                fixed
                fab
                color="accent"
                right
                bottom
                class="hidden-md-and-up"
                @click="addRecordDialog = true"
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import MedicalRecordDetails from "../components/MedicalRecordDetails";
    
    import * as compressor from "../FileCompress";

    export default {
        name: "MyMedicalRecords",
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        components: {
            MedicalRecordDetails,
            
        },
        mounted() {
            let inputs = document.querySelectorAll('.v-file-input input');
            [...inputs].forEach((input) => {
                input.remove()
            })

            if(this.$route.params.id){
                
                this.showDetail = true
                this.getMedicalRecords()
                .then(()=>{                                                
                    this.getMedicalRecordDetails(this.$route.params.id)
                })
                
            }else
                this.getMedicalRecords();
                
            
            
        },
        methods: {
            getMedicalRecordDetails(recordId){      
                return new Promise((resolve) => {
                    this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/medical-records/`+recordId)
                    .then((response) => {
                        this.showDetail = false      
                        if (response.data.status === 1) {
                            this.medicalRecordDetails = response.data.data 
                                                                                          
                        }
                        
                    }).catch((error) => {
                        console.log(error);
                    }).finally(() => {
                        this.loading = false
                        resolve()
                    })
                })          
                
            },            
            showMedicalRecordDetails(medicalRecord) {
                this.medicalRecordDetails = medicalRecord;                
                this.sheet = true;
            },
            gotoVideo(appointment) {
                this.$router.push({
                    name: 'appointmentCall', params: {
                        appointmentId: appointment.id
                    }
                })
            },
            async uploadRecord() {
                
                var multipleFiles = document.getElementById('attachments').files                
                var compressedFiles = await compressor.compressMultipleFiles(multipleFiles)

                if(!compressor.validateFileSizes(compressedFiles)){
                    this.$store.commit('showSnackbar', {message:"File too large"})
                    return;                    
                }
                this.saveLoading = true
                // if(compressor.validateFileSizes(compressedFiles)){

                // }

                let form = document.getElementById("addMedicalRecord")                                
                let formData = new FormData(form)                
                formData.set('attachments[]',null)
                compressedFiles.forEach((input) => {
                    formData.append('attachments[]',input)
                })

                
                                    
                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/${this.userInfo.id}/medical-records`, 
                formData,
                {
                    headers:{
                        'Content-Type' : 'multipart/form-data'
                    }
                })
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.uploadSucess = 1;
                            this.getMedicalRecords();
                            form.reset();
                            document.getElementsByClassName("v-file-input__text")[0].innerHTML = "";
                        }
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.saveLoading = false
                    })
            },
            getMedicalRecords: function () {
                if (!this.userInfo) {
                    return;
                }
                this.loadingMedicalRecords = true;
                this.filters.page = this.page;
                this.filters.record_type = this.recordFilter
                    return new Promise((resolve) => {
                        this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/${this.userInfo.id}/medical-records`, {
                        params: this.filters
                    }).then((response) => {
                        if (response.data.status === 1) {
                            this.medicalRecordsPaginationDetails = response.data.data;
                            this.medicalRecordsList = this.medicalRecordsPaginationDetails.data;

                            if (this.medicalRecordsList.length && !this.showDetail) {
                                this.medicalRecordDetails = this.medicalRecordsList[0];                            
                            }
                                                    
                        }
                        this.loadingMedicalRecords = false;
                    }).catch((error) => {
                        console.log(error);
                        this.loadingMedicalRecords = false;
                    })
                    .finally(() => {                        
                        resolve()
                    })
                 })
                
            },

        },
        data: () => ({
            sheet: false,
            addRecordDialog: false,
            uploadSucess: false,
            saveLoading: false,
            uploadFileName:null,
            recordTitle:"",
            recordType: 'Prescription',
            recordTypes: ['Prescription', 'Medical Report'],
            filters: {
                format_type: 'paginate',
                limit: 6
            },
            medicalRecordsPaginationDetails: {},
            page: 1,
            loadingMedicalRecords: false,
            medicalRecordsList: [],
            recordFilter: '',
            recordFilters: [
                {
                    text:'All Records',
                    value:'',
                },
                {
                    text:'Prescription',
                    value:'Prescription',
                },
                {
                    text:'Medical Report',
                    value:'Medical Report',
                }                
            ],
            medicalRecordDetails: {},       
            showDetail:false,                             
        }),
        watch:{
            addRecordDialog(){
                
                this.recordTitle = ""
                this.uploadFileName=null
                document.getElementById("addMedicalRecord").reset();
            },
            recordFilter(){
                this.getMedicalRecords()
            }
        }
    }
</script>

<style>
    .banner-cards {
        border: 1px solid #e9c68e !important;
    }

    .banner-cards .card__actions {
        padding: 4px 8px !important;
    }

    .solo-bordered .v-input__slot {
        border: 1px solid #ccc;
    }
</style>